<template>
  <div class="shortMes-index mt20">
    <el-form
      ref="shortForm"
      :model="shortRuleForm"
      :rules="shortRules"
      class="demo-ruleForm"
    >
      <el-form-item label="+86" prop="mobile" class="numItem">
        <el-input
          v-model="shortRuleForm.mobile"
          placeholder="请输入手机号"
          maxlength="11"
          class="el-int"
        ></el-input>
      </el-form-item>
      <el-form-item label="" prop="code" class="mt20">
        <el-input
          v-model="shortRuleForm.code"
          maxlength="6"
          class="el-int code code2"
        ></el-input>
        <el-button type="primary" class="send" @click="send" v-if="isShowSend"
          >发送验证码</el-button
        >
        <div class="sendTime" v-if="!isShowSend">{{ timeNum }}S重新发送</div>
      </el-form-item>
      <el-button
        type="primary"
        :class="isAffirm ? 'register-btn isAffirm' : 'register-btn'"
        :disabled="!isAffirm"
        @click="submit(shortForm)"
        >登录</el-button
      >
    </el-form>
    <div class="bottom">
      <!-- <div class="pas"> -->
      <!-- <el-checkbox
          v-model="checked"
          size="large"
          class="checkbox"
        ></el-checkbox>
        <span class="span">记住密码</span> -->
      <!-- </div> -->
      <div class="r-text">
        <a v-if="windowW > 850" @click="toRegister('register')">注册</a>
        <!-- <a v-else href="/register">注册</a> -->
        <router-link v-else to="/register">注册</router-link>
        <!-- <a href="/forgetPassword">忘记密码</a> | <a href="/register">注册</a> -->
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import {
  reactive,
  ref,
  toRefs,
  defineComponent,
  onBeforeMount,
  inject,
  watchEffect,
} from "vue";
import { ElForm, ElMessage } from "element-plus";
import { sendCode, mobileLogin } from "@/api/login";
import { useRouter, useRoute } from "vue-router";
type FormInstance = InstanceType<typeof ElForm>;
export default defineComponent({
  name: "shortMessageLogin",
  setup() {
    const isShowSend = ref(true);
    const timeNum = ref(60);
    const countDown = ref();
    const checked = ref(true);
    const router = useRouter();
    const route = useRoute();
    const shortForm = ref<FormInstance>();
    const formRoute = localStorage.getItem("formRoute"); //获取上一页路径
    const isAffirm = ref(false);
    const shortRuleForm = reactive({
      mobile: "",
      code: "",
    });

    onBeforeMount(() => {
      shortRuleForm.mobile = localStorage.getItem("mobile")
        ? (localStorage.getItem("mobile") as string)
        : "";
    });

    const vaildateMobile = (rule: any, value: any, callback: any) => {
      if (!/^1(3|4|5|6|7|8|9)\d{9}$/.test(value)) {
        callback(new Error("请输入正确的手机号"));
      } else {
        callback();
      }
    };
    const shortRules = reactive({
      mobile: [
        {
          required: true,
          message: "请输入手机号",
          trigger: "blur",
        },
        { validator: vaildateMobile, trigger: "change" },
      ],
      code: [
        {
          required: true,
          message: "请输入验证码",
          trigger: "blur",
        },
      ],
    });

    // 发送验证码
    const send = (): void => {
      sendCode({ mobile: shortRuleForm.mobile }).then((res: any) => {
        if (res.code == 0) {
          ElMessage.success(res.msg);
          getSetInterval();
        }
      });
    };

    //倒计时60s
    const getSetInterval = (): void => {
      timeNum.value = 60;
      countDown.value = setInterval(() => {
        setTimeout(() => {
          if (timeNum.value > 0 && timeNum.value <= 60) {
            isShowSend.value = false;
            timeNum.value--;
          } else {
            isShowSend.value = true;
            clearInterval(countDown.value);
          }
        }, 0);
      }, 1000);
    };

    const submit = (formEl: FormInstance | undefined): void => {
      (formEl as any).validate((valid: any) => {
        if (valid) {
          mobileLogin(shortRuleForm).then((res: any) => {
            if (res.code == 0) {
              if (checked.value) {
                localStorage.setItem("mobile", shortRuleForm.mobile);
              }
              ElMessage.success(res.msg);
              localStorage.setItem("userInfo", JSON.stringify(res.data.info));
              localStorage.setItem(
                "authorization",
                res.data.info.authorization
              );
              localStorage.setItem("expirationTime", res.data.info.ex_time);
              if (windowW > 850) {
                location.reload();
              } else {
                if (
                  location.origin == "https://pay2.diancang.site" ||
                  location.origin == "https://zhishiquan.online"
                ) {
                  console.log("formRoute", formRoute);
                  if (formRoute) {
                    location.href =
                      location.origin + "/official-web" + formRoute;
                  } else {
                    location.href = "/official-web/";
                  }
                } else {
                  if (formRoute) {
                    location.href = location.origin + formRoute;
                  } else {
                    location.href = "/";
                  }
                }
              }
            }
          });
        }
      });
    };

    const myInject: any = inject("register");

    const toRegister = (val: string) => {
      myInject(val);
    };

    watchEffect(() => {
      if (shortRuleForm.mobile.length == 11 && shortRuleForm.code.length == 6) {
        isAffirm.value = true;
      } else {
        isAffirm.value = false;
      }
    });
    // 判断是pc端还是移动端
    const windowW = window.innerWidth;
    return {
      windowW,
      submit,
      send,
      isShowSend,
      timeNum,
      countDown,
      checked,
      shortForm,
      shortRuleForm,
      shortRules,
      toRegister,
      isAffirm,
    };
  },
});
</script>
<style lang="less">
.shortMes-index .code .el-input__inner {
  width: 100% !important;
}
@media only screen and (max-width: 850px) {
  .shortMes-index {
    .code {
      width: 3.2rem !important;
    }
    .el-form-item {
      margin-bottom: 16px;
    }
  }
}
</style>
<style lang="less" scoped>
@import url("@/assets/styles/common.less");
.shortMes-index {
  .demo-ruleForm {
    .code2 {
      width: 49% !important;
    }
  }
  .send {
    border: none;
    .boxSize(49%,40px);
    background-color: #f4f4f4;
    .font(#191c29,15px);
  }
  .sendTime {
    .boxSize(160px,40px);
    border-radius: 4px;
    background-color: #f0f0f0;
    .font(#9f9f9f,15px);
    border: none;
    line-height: 40px;
    text-align: center;
  }
  .register-btn {
    border: none;
    .boxSize(100%,40px);
    background: #f1f1f1;
    .font(#D1D2D5,16px);
    &:hover {
      background: #f1f1f1;
      .font(#D1D2D5,16px);
    }
    &.isAffirm {
      background: #ffca28;
      color: #333333;
      &:hover {
        background: #ffca28;
        color: #333333;
      }
    }
  }
  .bottom {
    .Flex(space-between,center);
    height: 20px;
    .pas {
      .font(#333333,14px);
      .span {
        .Position(relative,6px,-2px);
      }
    }
    .r-text {
      user-select: none;
      .font(#999999,14px);
      a {
        color: #999999;
      }
    }
  }
}
@media only screen and (max-width: 850px) {
  .r-text {
    margin-top: 10px;
  }
  .shortMes-index {
    padding-top: 0.5rem;
    .send {
      background-color: #f4f4f4;
      &:hover {
        background: #f4f4f4;
        color: #999999;
      }
    }
    .send {
      background: #f4f4f4;
      color: #999999;
      .boxSize(3.2rem,40px);
    }
    .sendTime {
      .boxSize(3.2rem,40px);
    }
    .register-btn {
      margin-top: 0.4rem;
    }
    .bottom {
      display: block;
      .r-text {
        float: right;
      }
    }
  }
}
</style>